import { useRemoteResource } from "./useRemoteResource";
import { useScoreApi, unwrap } from "../api/scoreApi";

// Classes for a show — used to derive the list of rings on offer (score-api
// has no dedicated ring-listing route; `class.ring` is FVD free text, so
// distinct values off the class list is the only source), AND by the Order
// of Go to label each class header (className/classNumber).
//
// #692 — `nonce` is the same entity-refresh beat useRidesForRing/
// useBreaksForRing take: bump it to force a revalidate (a class renamed/
// renumbered, or newly added, mid-show).
//
// #2190 — no local cache: a network failure leaves whatever classes are
// already on screen exactly as they are (see useRemoteResource). A null
// showId is a no-op (nothing picked yet).
export function useClassesForShow(showId, nonce = 0) {
  const api = useScoreApi();
  return useRemoteResource(async () => {
    if (!showId) return [];
    return unwrap(await api.classes.listClasses(showId));
  }, [api, showId, nonce]);
}
